import { render, staticRenderFns } from "./coin_ticker.vue?vue&type=template&id=1bc1d5f6&"
import script from "./coin_ticker.vue?vue&type=script&lang=js&"
export * from "./coin_ticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports